import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["message"];
  static values = {
    notifyEnabled: Boolean,
    userWants: Boolean,
    status: String,
    willNotifyText: String,
    wontNotifyText: String,
  };

  connect() {
    this.updateMessage();
  }

  updateMessage() {
    const messageEl = this.messageTarget;
    if (this.notifyEnabledValue && this.userWantsValue) {
      messageEl.textContent = this.willNotifyTextValue;
      messageEl.classList.add("text-emerald-600", "dark:text-emerald-400");
      messageEl.classList.remove("text-amber-600", "dark:text-amber-400");
    } else {
      messageEl.textContent = this.wontNotifyTextValue;
      messageEl.classList.add("text-amber-600", "dark:text-amber-400");
      messageEl.classList.remove("text-emerald-600", "dark:text-emerald-400");
    }
  }
}
